<template>
  <div></div>
</template>

<script>
import testChild from './testChild';

export default {
  name: 'test',
  components: {
    testChild,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    test() {
      console.log('test');
    },
  },
};
</script>
